module.exports = __webpack_public_path__ + "media/images/logo-lucasistencia-square-b21da8060ee83e129eb4383a17bba8a6.png";